module.exports = __webpack_public_path__ + "static/media/track-mazda.21bac89c.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/track-mazda.png
// module id = 1032
// module chunks = 0